module.exports = __webpack_public_path__ + "img/智能家居.dea11211.png";